function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cancela{fill:#d56868;}"));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(-1542.227 -9895.42)"
}, /*#__PURE__*/React.createElement("path", {
  className: "cancela",
  d: "M1577.727,9900.492a30.428,30.428,0,1,1-30.429,30.428,30.463,30.463,0,0,1,30.429-30.428m0-5.072a35.5,35.5,0,1,0,35.5,35.5,35.5,35.5,0,0,0-35.5-35.5Z"
}), /*#__PURE__*/React.createElement("g", {
  transform: "translate(1574.343 9913.593)"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(0.849)"
}, /*#__PURE__*/React.createElement("path", {
  className: "cancela",
  d: "M1583.763,9937.863a2.536,2.536,0,0,1-2.536-2.535v-15.872a2.536,2.536,0,1,1,5.071,0v15.872A2.535,2.535,0,0,1,1583.763,9937.863Z",
  transform: "translate(-1581.227 -9916.92)"
})), /*#__PURE__*/React.createElement("circle", {
  className: "cancela",
  cx: 3.384,
  cy: 3.384,
  r: 3.384,
  transform: "translate(0 25.351)"
})));

var SvgCancel = function SvgCancel(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 71,
    height: 71,
    viewBox: "0 0 71 71",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCancel, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/cancel.52a70312.svg";
export { ForwardRef as ReactComponent };